/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'prescription': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" clip-rule="evenodd" d="M14 7a3 3 0 013-3h6a3 3 0 013 3v.333h2.571c2.42 0 4.429 1.914 4.429 4.334v20C33 34.087 30.99 36 28.571 36H11.43C9.009 36 7 34.086 7 31.667v-20c0-2.42 2.01-4.334 4.429-4.334H14zm12 2.667v-.334h2.571c1.368 0 2.429 1.071 2.429 2.334v20C31 32.929 29.94 34 28.571 34H11.43C10.06 34 9 32.929 9 31.667v-20c0-1.263 1.06-2.334 2.429-2.334H14v.334a3 3 0 003 3h6a3 3 0 003-3zM17 6a1 1 0 00-1 1v2.667a1 1 0 001 1h6a1 1 0 001-1V7a1 1 0 00-1-1zm4 12.62a1 1 0 10-2 0v3.713h-3.714a1 1 0 000 2H19v3.714a1 1 0 102 0v-3.714h3.714a1 1 0 100-2H21z" _fill="#1f222c" fill-rule="evenodd"/>'
  }
})
